export default class StopwatchStorage {
    static setIsStopwatchRunning(isStopwatchRunning) {
        sessionStorage.setItem('isStopwatchRunning', isStopwatchRunning);
    }

    static getIsStopwatchRunning() {
        return sessionStorage.getItem('isStopwatchRunning') == "true" || false;
    }
}
